import React, { useState, useEffect, useRef } from 'react';
import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import { captureException } from "~/utilities/sentry.utility";

const DeleteScreenerConfirmationModal: React.FC<{ isOpen: boolean, onClose: (isOpen: boolean) => void, screenerId: any }> = ({ isOpen, onClose, screenerId }) => {


    const handleSave = async () => {
        try {
            const response = await axios.post('/api/delete/screener', {
                data: {
                    screenerId: screenerId
                }
            });
            if (response.status === 200) {
                window.location.reload();
            }
        } catch (error) {
            console.error('Error saving screener:', error);
            captureException(error);
            // Optional: Add error notification
        }
    };

    return (
        <div className="search-modal">
            <Dialog open={isOpen} onClose={() => { }} className="relative z-[60]">
                <DialogBackdrop
                    className="fixed inset-0 bg-gray-500/75"
                />

                <div className="fixed inset-0 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <DialogPanel
                            className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all"
                        >
                            <h5 className="text-1xl font-bold">Are you sure you want to delete this screener?</h5>
                            <div className="absolute right-0 top-0 pr-4 pt-4">
                                <button
                                    type="button"
                                    onClick={() => onClose(false)}
                                    className="rounded-md bg-white text-gray-900 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
                                >
                                    <FontAwesomeIcon icon={faCircleXmark} className="size-6" />
                                </button>
                            </div>
                            <div className="mt-10 text-center sm:ml-4 sm:text-left">
                                <div className="relative">

                                    <div className='mt-0'>

                                    </div>
                                    <div className="mt-4">
                                        <div className="flex justify-center space-x-4">

                                            <button
                                                type="button"
                                                className="inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-red-600 border border-transparent rounded-md shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                                                onClick={() => onClose(false)}
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                type="button"
                                                className="inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-black border border-transparent rounded-md shadow-sm hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2"
                                                onClick={handleSave}
                                            >
                                                Proceed
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
        </div>
    );
};

export default DeleteScreenerConfirmationModal;
